import { render, staticRenderFns } from "./MatchAlertBeacon.vue?vue&type=template&id=633e9aac&scoped=true"
import script from "./MatchAlertBeacon.vue?vue&type=script&lang=js"
export * from "./MatchAlertBeacon.vue?vue&type=script&lang=js"
import style0 from "./MatchAlertBeacon.vue?vue&type=style&index=0&id=633e9aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e9aac",
  null
  
)

export default component.exports